import { deleteData, getData, postData, putData } from "./APIServiceInterface";

export const getRegionsService = async () => {
    //const response = getData("/usersJSON/regionRes.json");
    //const response = getData("/usersJSON/mockRegion.json");
    const response = getData("region/get");
    return response;
};

export const getSalesOfficeService = async () => {
    //const response = getData("/usersJSON/salesOfficeRes.json");
    //const response = getData("/usersJSON/mockSalesOffice.json");
    const response = getData("salesOffice/get")
    return response;
};

export const getRolesService = async () => {
    //const response = getData("/usersJSON/roleRes.json");
    //const response = getData("/usersJSON/MockRoles.json");
    const response = getData("role/get");
    return response;
};

export const getUserRegionService = async () => {
    //const response = getData("/usersJSON/userRegionRes.json");
    //const response = getData("/usersJSON/mockUserRegion.json");
    const response = getData("user/get");
    return response;
};

export const getByRegionUserService = async (payload) => {
    const response = getData(`user/getByRegion?regionId=${payload.regionId}`);
    return response;
};

export const getUserSalesOfficeService = async () => {
    const response = getData("/usersJSON/mockUserSalesOffice.json");
    //const response = getData("/usersJSON/userSalesOfficeRes.json");
    return response;
};

export const createNewUserService = async (payload) => {
    const response = await putData("user/create", payload);
    return response;
};

export const updateUserService = async (payload) => {
    return await postData(`user/update?userId=${payload.userId}`, payload);
};

export const deleteUserService = async (payload) => {
    return await deleteData(`user/delete?userId=${payload.userId}`);
};

export const getRegionBasedSalesOfficeService = async(payload) => {
    return await getData(`salesOffice/getByRegion?regionId=${payload}`);
}
